// Facts about an environment derived from the API's lists: its Incus instance name and how
// many of its runs are live.
import type { Environment, Organisation, Run, Workflow } from "../../api/client";
import { ACTIVE_RUN } from "../../ui/tones";

export function instanceName(env: Environment, org: Organisation | undefined): string {
  return org ? `org-${org.slug}/env-${env.slug}` : `env-${env.slug}`;
}

/** Runs of the environment's workflows that hold or may hold a worker now. */
export function liveRuns(env: Environment, workflows: Workflow[], runs: Run[]): number {
  const mine = new Set(workflows.filter((w) => w.environment_id === env.id).map((w) => w.id));
  return runs.filter((r) => mine.has(r.workflow_id) && ACTIVE_RUN.has(r.status)).length;
}
